<div class="container-modal">
	<div class="container">
		<div class="container-modal-body container-modal-body-call p-5 responsive_1">
			<form [formGroup]="formGroup">
				<div class="row justify-content-end h-100" *ngIf="!phoneConfirmed">
					<div class="col col-sm-6 col-md-7 col-lg-5 bg-primary rounded container-content responsive_4">
						<p class="fs-6 fw-bold">{{ 'clickToCall.weCallYou' | translate }}</p>
						<p class="fs-6 mb-2" *ngIf="!phoneInput && savedPhoneNumber && savedPhonePrefix">
							{{ 'common.phone' | translate }}:
						</p>
						<p class="fs-6 fw-medium" *ngIf="!phoneInput && savedPhoneNumber && savedPhonePrefix">
							{{ savedPhonePrefix }} {{ savedPhoneNumber }}
						</p>
						<div class="form-check" *ngIf="savedPhoneNumber && savedPhonePrefix">
							<input
								class="form-check-input"
								type="checkbox"
								name="checkOtherPhone"
								id="checkOtherPhone"
								(change)="showPhoneInput($event)"
							/>
							<label class="form-check-label ms-2 mt-1" for="checkOtherPhone">
								{{ 'clickToCall.otherPhone' | translate }}
							</label>
						</div>
						<div *ngIf="phoneInput || !(savedPhoneNumber && savedPhonePrefix)">
							<label for="exampleFormControlInput1">{{ 'common.phone' | translate }}</label>
							<div class="input-group">
								<div ngbDropdown>
									<button
										type="button"
										class="btn btn-light rounded-0 rounded-start w-100"
										id="dropdownBasic1"
										ngbDropdownToggle
									>
										{{ formGroup.get('phonePrefix')?.value }}
									</button>
									<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
										<button ngbDropdownItem *ngFor="let prefix of prefixList" (click)="onSelectPrefix(prefix)">
											{{ prefix }}
										</button>
									</div>
								</div>
								<input
									*ngIf="formGroup.get('phonePrefix')?.value === '+34'"
									type="text"
									class="form-control"
									id="exampleFormControlInput1"
									placeholder="{{ 'common.phone' | translate }}"
									maxlength="9"
									minlength="9"
									onlyNumber
									formControlName="phoneNumber"
								/>
								<input
									*ngIf="formGroup.get('phonePrefix')?.value !== '+34'"
									type="text"
									class="form-control"
									id="exampleFormControlInput1"
									placeholder="{{ 'common.phone' | translate }}"
									formControlName="phoneNumber"
								/>
							</div>
							<validation-messages [control]="formGroup.get('phoneNumber')"></validation-messages>
						</div>
						<div class="termCall">
							<p class="mb-2">
								{{ 'claimConfirm.disclaimer.call' | translate }}
							</p>
							<a href="{{ 'footer.dataProtectionWeb' | translate }}" target="_blank">{{ 'footer.dataProtectionWeb' | translate }}</a>
							<div class="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									name="checkRead"
									id="checkRead"
									(change)="acceptTerms()"
								/>
								<label class="form-check-label ms-2 mt-1" for="checkRead">
									{{ 'claimConfirm.disclaimer.read' | translate }}
								</label>
							</div>
						</div>
						<div class="d-flex align-items-center justify-content-center w-100">
							<button
								[disabled]="formGroup.invalid || !termAccepted"
								type="button"
								class="btn bg-white d-flex align-items-center justify-content-center w-100 w-md-initial mt-5"
								(click)="callConfirmPhone()"
							>
								<i class="icon hs-icon-phone"></i>
								<span class="text-primary">{{ 'clickToCall.buttonMsg' | translate }}</span>
							</button>
						</div>
					</div>
				</div>
			</form>
			<div class="row justify-content-end" *ngIf="phoneConfirmed">
				<div class="col col-sm-6 col-md-7 col-lg-5 bg-primary rounded container-content">
					<div class="d-flex align-items-start">
						<i class="hs-icon-ok fs-2"></i>
						<p class="fs-6 fw-bold ms-3">{{ 'clickToCall.phoneReceived' | translate }}</p>
					</div>
					<p class="fs-6 ms-5 mb-2">
						{{ 'clickToCall.processFinished' | translate }}
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
